import media from 'decorators/Media/Media';
import { UserQuote } from './UserQuote';
export var UserQuoteContainer = media(UserQuote);